const cartDrawer = document.getElementById("cart-drawer");
const cartMask = document.getElementById("cart-drawer-mask");
const cartTarget = document.getElementById("mini-cart-target");
const cartTrigger = document.querySelector(".cart-trigger");

// Host for the pre-checkout add-on step. Declared here because the drawer's
// initial hidden state is applied long before the step block below runs.
let upsellHost = null;

function getCategoryContextSlug() {
  if (typeof ThemeJS === "undefined" || !ThemeJS.Variables) {
    return "";
  }
  return ThemeJS.Variables.CategoryContext || "";
}

function getDisplayedCartCount() {
  const el = document.querySelector("span.cart-count");
  if (!el) {
    return 0;
  }
  if (el.classList.contains("empty-cart-count")) {
    return 0;
  }
  const n = parseInt(el.textContent, 10);
  return Number.isFinite(n) ? n : 0;
}

function setCartCount(count) {
  const el = document.querySelector("span.cart-count");
  if (!el) {
    return;
  }
  const n = Math.max(0, parseInt(count, 10) || 0);
  el.textContent = String(n);
  el.classList.toggle("empty-cart-count", n === 0);
  el.setAttribute("aria-hidden", "true");
  // The badge is aria-hidden, so the button's accessible name carries the count.
  const srCount = document.querySelector(".cart-trigger .cart-count-sr");
  if (srCount) {
    srCount.textContent = n === 1 ? "1 item" : `${n} items`;
  }
  if (cartTrigger) {
    cartTrigger.setAttribute("data-server-cart-count", String(n));
  }
}

/**
 * Read count from a cart-count fragment HTML string (from WC add-to-cart response).
 */
function cartCountFromFragmentHtml(html) {
  if (!html) {
    return null;
  }
  const tmp = document.createElement("div");
  tmp.innerHTML = html;
  const span = tmp.querySelector("span.cart-count");
  if (!span) {
    return null;
  }
  if (span.classList.contains("empty-cart-count")) {
    return 0;
  }
  const n = parseInt(span.textContent, 10);
  return Number.isFinite(n) ? n : 0;
}

/**
 * Infer item count from mini-cart HTML when the drawer loads (badge must match drawer).
 */
function cartCountFromMiniCartHtml(root) {
  if (!root) {
    return 0;
  }
  if (root.querySelector(".woocommerce-mini-cart__empty-message")) {
    return 0;
  }
  let total = 0;
  root.querySelectorAll(".mini_cart_item").forEach((item) => {
    const removeBtn = item.querySelector("[data-quantity]");
    if (removeBtn) {
      const q = parseInt(removeBtn.getAttribute("data-quantity"), 10);
      if (Number.isFinite(q) && q > 0) {
        total += q;
        return;
      }
    }
    const qtyEl = item.querySelector(".quantity");
    if (qtyEl) {
      const q = parseInt(qtyEl.textContent, 10);
      if (Number.isFinite(q) && q > 0) {
        total += q;
        return;
      }
    }
    total += 1;
  });
  return total;
}

function clearStaleCartFragments() {
  if (typeof wc_cart_fragments_params === "undefined" || typeof sessionStorage === "undefined") {
    return;
  }
  try {
    sessionStorage.removeItem(wc_cart_fragments_params.fragment_name);
  } catch (e) {
    // Ignore storage errors (private mode, etc.).
  }
}

function getWooCartHashCookie() {
  if (typeof Cookies !== "undefined" && typeof Cookies.get === "function") {
    return Cookies.get("woocommerce_cart_hash") || "";
  }
  const match = document.cookie.match(/(?:^|;\s*)woocommerce_cart_hash=([^;]*)/);
  return match ? decodeURIComponent(match[1]) : "";
}

/**
 * Keep data-server-cart-count aligned with the live badge after add/remove/refresh.
 * Prevents the page-load attr (often 0) from wiping a just-updated count.
 */
function syncServerCartCountAttr(fragments) {
  if (fragments && fragments["span.cart-count"]) {
    const fromFragment = cartCountFromFragmentHtml(fragments["span.cart-count"]);
    if (fromFragment !== null) {
      setCartCount(fromFragment);
      return;
    }
  }
  if (cartTrigger) {
    cartTrigger.setAttribute(
      "data-server-cart-count",
      String(getDisplayedCartCount()),
    );
  }
}

// WooCommerce: admin-ajax and ?wc-ajax=… lack the main query; pass category_context like the current page.
if (typeof jQuery !== "undefined") {
  jQuery(document).ajaxSend(function (_event, _jqXHR, settings) {
    const ctx = getCategoryContextSlug();
    if (!ctx || !settings.url) {
      return;
    }
    const url = String(settings.url);
    const blob = url + String(settings.data || "");
    if (blob.indexOf("category_context=") !== -1) {
      return;
    }
    const isAdminAjax = url.indexOf("admin-ajax.php") !== -1;
    const isWcAjax = url.indexOf("wc-ajax=") !== -1 || url.indexOf("wc-ajax%3D") !== -1;
    if (!isAdminAjax && !isWcAjax) {
      return;
    }
    if (typeof settings.data === "string" && settings.data.length) {
      settings.data += "&category_context=" + encodeURIComponent(ctx);
    } else if (typeof FormData !== "undefined" && settings.data instanceof FormData) {
      settings.data.append("category_context", ctx);
    } else if (settings.data && typeof settings.data === "object" && !(settings.data instanceof FormData)) {
      settings.data.category_context = ctx;
    } else {
      const sep = url.indexOf("?") === -1 ? "?" : "&";
      settings.url += sep + "category_context=" + encodeURIComponent(ctx);
    }
  });

  // After add/remove, fragments update the badge but not data-server-cart-count (page-load only).
  jQuery(document.body).on(
    "added_to_cart removed_from_cart wc_fragments_refreshed",
    function (_event, fragments) {
      syncServerCartCountAttr(fragments);
    },
  );

  // sessionStorage can re-apply a stale badge when cart_hash and cookie are both empty.
  // Only squash an inflated badge when PHP rendered empty AND cookies agree the cart is empty.
  // Do not fire wc_fragment_refresh here — that races with a quick add-to-cart and can zero the badge.
  jQuery(document.body).on("wc_fragments_loaded", function () {
    if (!cartTrigger) {
      return;
    }
    const server =
      parseInt(cartTrigger.getAttribute("data-server-cart-count") || "0", 10) ||
      0;
    const shown = getDisplayedCartCount();
    if (server === shown) {
      return;
    }
    if (server === 0 && shown > 0 && !getWooCartHashCookie()) {
      clearStaleCartFragments();
      setCartCount(0);
      return;
    }
    // PHP had items (or cookies claim a cart) but fragments disagreed — prefer PHP, then refresh once.
    setCartCount(server);
    jQuery(document.body).trigger("wc_fragment_refresh");
  });
}

// Focus trap for the drawer: the panel is always in the DOM, so without this its
// controls stay tabbable behind the mask and the dialog can be tabbed out of.
let cartFocusTrap = null;
if (cartDrawer && typeof focusTrap !== "undefined") {
  cartFocusTrap = focusTrap.createFocusTrap(cartDrawer, {
    escapeDeactivates: true,
    clickOutsideDeactivates: true,
    returnFocusOnDeactivate: true,
    onDeactivate() {
      setCartDrawerVisible(false);
    },
  });
}

/**
 * Show/hide state only. Focus handling lives in toggleCart().
 */
function setCartDrawerVisible(show) {
  if (!cartDrawer || !cartMask) {
    return;
  }
  cartDrawer.classList.toggle("is-open", show);
  cartMask.classList.toggle("is-visible", show);
  if (!show) {
    // The bag is what the drawer opens on; a half-finished add-on step is not.
    closeUpsellStep();
  }
  cartDrawer.setAttribute("aria-hidden", show ? "false" : "true");
  // `inert` keeps the off-screen panel out of the tab order in browsers that
  // support it; the focus trap covers the rest.
  if (show) {
    cartDrawer.removeAttribute("inert");
  } else {
    cartDrawer.setAttribute("inert", "");
  }
  if (cartTrigger) {
    cartTrigger.setAttribute("aria-expanded", show ? "true" : "false");
  }
}

function toggleCart(show = true) {
  if (!cartDrawer || !cartMask) {
    return;
  }
  if (show) {
    // The drawer is the fuller confirmation; the toast would sit under it.
    hideCartToast();
    setCartDrawerVisible(true);
    if (cartFocusTrap) {
      cartFocusTrap.activate();
    } else {
      const closeBtn = document.getElementById("close-cart");
      if (closeBtn) {
        closeBtn.focus();
      }
    }
    //document.body.style.overflow = "hidden"; // Prevents background scroll
  } else if (cartFocusTrap) {
    // onDeactivate() hides the drawer and returns focus to the trigger.
    cartFocusTrap.deactivate();
  } else {
    setCartDrawerVisible(false);
    if (cartTrigger) {
      cartTrigger.focus();
    }
    //document.body.style.overflow = "";
  }
}

// Closed on load: mirror that in the a11y tree before any interaction.
setCartDrawerVisible(false);

// ---------------------------------------------------------------------------
// Mini-cart rendering
// ---------------------------------------------------------------------------

const cartStatus = document.getElementById("cart-drawer-status");

// cart_item_key -> quantity from the last render. Null until the drawer has
// rendered once, so the first add of a page view cannot highlight anything.
let cartSnapshot = null;
let miniCartPending = false;
let miniCartQueued = false;

/**
 * Push a message to the drawer's status region. The panel sliding open is the
 * confirmation for sighted users; screen readers get nothing from that, so the
 * announcement is the only signal they receive.
 */
function announceCart(message) {
  if (!cartStatus || !message) {
    return;
  }
  // Re-setting the same string is not re-announced, so clear it first.
  cartStatus.textContent = "";
  window.setTimeout(() => {
    cartStatus.textContent = message;
  }, 50);
}

function snapshotMiniCart(root) {
  const map = new Map();
  if (!root) {
    return map;
  }
  root.querySelectorAll(".mini_cart_item").forEach((item) => {
    const remove = item.querySelector("[data-cart_item_key]");
    const key = remove ? remove.getAttribute("data-cart_item_key") : "";
    if (!key) {
      return;
    }
    const qty = parseInt(remove.getAttribute("data-quantity"), 10);
    map.set(key, Number.isFinite(qty) && qty > 0 ? qty : 1);
  });
  return map;
}

function cartItemName(item) {
  const el = item.querySelector(".product-title");
  return el ? el.textContent.trim() : "";
}

/**
 * Flag rows that are new (or whose quantity went up) since the previous render.
 * An add that merges into an existing line only changes a small quantity badge,
 * which is easy to miss without it.
 */
function highlightCartChanges(root, previous) {
  const changed = [];
  if (!root || !previous) {
    return changed;
  }
  root.querySelectorAll(".mini_cart_item").forEach((item) => {
    const remove = item.querySelector("[data-cart_item_key]");
    const key = remove ? remove.getAttribute("data-cart_item_key") : "";
    if (!key) {
      return;
    }
    const qty = parseInt(remove.getAttribute("data-quantity"), 10) || 1;
    const before = previous.has(key) ? previous.get(key) : 0;
    if (qty > before) {
      item.classList.add("is-new");
      changed.push(cartItemName(item));
    }
  });
  if (changed.length) {
    const first = root.querySelector(".mini_cart_item.is-new");
    if (first && typeof first.scrollIntoView === "function") {
      first.scrollIntoView({ block: "nearest", behavior: "smooth" });
    }
  }
  return changed;
}

/**
 * Fetch the mini-cart via AJAX (PHP has no category archive context on this
 * request). Concurrent calls collapse into one trailing refresh.
 */
function refreshMiniCart({ announce = false } = {}) {
  if (!cartTarget || typeof wc_add_to_cart_params === "undefined") {
    return;
  }
  if (miniCartPending) {
    miniCartQueued = true;
    return;
  }
  miniCartPending = true;

  const miniCartParams = new URLSearchParams({ action: "get_mini_cart" });
  const ctx = getCategoryContextSlug();
  if (ctx) {
    miniCartParams.set("category_context", ctx);
  }

  cartTarget.setAttribute("aria-busy", "true");
  fetch(wc_add_to_cart_params.ajax_url + "?" + miniCartParams.toString())
    .then((res) => res.text())
    .then((html) => {
      const previous = cartSnapshot;
      cartTarget.innerHTML = html;
      cartTarget.setAttribute("aria-busy", "false");
      const changed = highlightCartChanges(cartTarget, previous);
      cartSnapshot = snapshotMiniCart(cartTarget);
      // Keep badge aligned with drawer contents (authoritative for this open).
      setCartCount(cartCountFromMiniCartHtml(cartTarget));
      syncUpsellStepAfterRefresh();
      if (announce) {
        announceCart(
          changed.length === 1 && changed[0]
            ? `${changed[0]} added to your bag.`
            : "Item added to your bag.",
        );
      }
    })
    .catch(() => {
      cartTarget.setAttribute("aria-busy", "false");
    })
    .finally(() => {
      miniCartPending = false;
      if (miniCartQueued) {
        miniCartQueued = false;
        refreshMiniCart({ announce });
      }
    });
}

// ---------------------------------------------------------------------------
// Coupon field
// ---------------------------------------------------------------------------

/**
 * The mini-cart is replaced wholesale on every refresh, so the coupon controls
 * are handled by delegation from the drawer's target rather than bound to the
 * markup that comes back.
 */
/**
 * WooCommerce notices arrive as HTML (tags, and entities like &quot;), but the
 * error slot is filled with textContent — so unwrap them here rather than
 * showing the markup verbatim. The element is never inserted into the document.
 */
function couponNoticeText(html) {
  const tmp = document.createElement("div");
  tmp.innerHTML = String(html || "");
  return (tmp.textContent || "").trim();
}

function couponError(message) {
  const box = cartTarget
    ? cartTarget.querySelector(".mini-cart-coupon__error")
    : null;
  if (!box) {
    return;
  }
  box.textContent = message || "";
  box.hidden = !message;
}

function setCouponFormOpen(open) {
  if (!cartTarget) {
    return;
  }
  const wrap = cartTarget.querySelector(".mini-cart-coupon");
  const toggle = cartTarget.querySelector(".mini-cart-coupon__toggle");
  const form = cartTarget.querySelector(".mini-cart-coupon__form");
  if (!wrap || !toggle || !form) {
    return;
  }
  wrap.setAttribute("data-open", open ? "true" : "false");
  toggle.setAttribute("aria-expanded", open ? "true" : "false");
  form.hidden = !open;
  if (open) {
    const input = form.querySelector(".mini-cart-coupon__input");
    if (input) {
      input.focus();
    }
  } else {
    couponError("");
  }
}

/**
 * POST a coupon action and re-render the drawer on success. Errors stay inline
 * so the shopper keeps the code they typed.
 */
function postCouponAction(action, code, nonce, button) {
  if (typeof wc_add_to_cart_params === "undefined") {
    return;
  }
  const body = new FormData();
  body.set("action", action);
  body.set("coupon_code", code);
  body.set("security", nonce);
  const ctx = getCategoryContextSlug();
  if (ctx) {
    body.set("category_context", ctx);
  }
  if (button) {
    button.disabled = true;
  }
  couponError("");

  fetch(wc_add_to_cart_params.ajax_url, { method: "POST", body })
    .then((res) => res.json().then((data) => ({ ok: res.ok, data })))
    .then(({ ok, data }) => {
      if (!ok || !data || data.success === false) {
        const message =
          data && data.data && data.data.message
            ? data.data.message
            : "That discount code could not be applied.";
        couponError(couponNoticeText(message));
        if (button) {
          button.disabled = false;
        }
        return;
      }
      // Line prices are untouched by a coupon, so the change is in the totals
      // block only — re-render rather than diffing.
      refreshMiniCart();
      announceCart(
        data.data && data.data.message
          ? couponNoticeText(data.data.message)
          : "Bag updated.",
      );
      if (typeof jQuery !== "undefined") {
        jQuery(document.body).trigger("wc_fragment_refresh");
      }
    })
    .catch(() => {
      couponError("Something went wrong. Try again.");
      if (button) {
        button.disabled = false;
      }
    });
}

if (cartTarget) {
  cartTarget.addEventListener("click", (event) => {
    const toggle = event.target.closest(".mini-cart-coupon__toggle");
    if (toggle) {
      setCouponFormOpen(toggle.getAttribute("aria-expanded") !== "true");
      return;
    }
    const remove = event.target.closest(".mini-cart-coupon__remove");
    if (remove) {
      const form = cartTarget.querySelector(".mini-cart-coupon__form");
      const nonce = form ? form.querySelector("#mini_cart_coupon_nonce") : null;
      postCouponAction(
        "commencement_remove_cart_coupon",
        remove.getAttribute("data-coupon-code") || "",
        nonce ? nonce.value : "",
        remove,
      );
    }
  });

  cartTarget.addEventListener("submit", (event) => {
    const form = event.target.closest(".mini-cart-coupon__form");
    if (!form) {
      return;
    }
    event.preventDefault();
    const input = form.querySelector(".mini-cart-coupon__input");
    const nonce = form.querySelector("#mini_cart_coupon_nonce");
    const code = input ? input.value.trim() : "";
    if (!code) {
      couponError("Enter a discount code.");
      return;
    }
    postCouponAction(
      "commencement_apply_cart_coupon",
      code,
      nonce ? nonce.value : "",
      form.querySelector(".mini-cart-coupon__apply"),
    );
  });
}

// Click listener for your cart icon (omitted when not in a product category context)
if (cartTrigger && cartTarget && typeof wc_add_to_cart_params !== "undefined") {
  cartTrigger.addEventListener("click", function (e) {
    e.preventDefault();
    toggleCart(true);
    refreshMiniCart();
  });
}

// ---------------------------------------------------------------------------
// Add-to-cart toast
// ---------------------------------------------------------------------------

const cartToast = document.getElementById("cart-toast");
const CART_TOAST_MS = 5000;
let cartToastTimer = null;

function hideCartToast() {
  if (!cartToast || cartToast.hidden) {
    return;
  }
  window.clearTimeout(cartToastTimer);
  cartToast.classList.remove("is-visible");
  // Wait for the slide-out before taking it out of the layout.
  window.setTimeout(() => {
    if (!cartToast.classList.contains("is-visible")) {
      cartToast.hidden = true;
    }
  }, 250);
}

function scheduleCartToastHide() {
  window.clearTimeout(cartToastTimer);
  cartToastTimer = window.setTimeout(hideCartToast, CART_TOAST_MS);
}

function showCartToast(name) {
  if (!cartToast) {
    return;
  }
  const nameEl = cartToast.querySelector("[data-cart-toast-name]");
  if (nameEl) {
    nameEl.textContent = name || "";
    nameEl.hidden = !name;
  }
  cartToast.hidden = false;
  // Two frames so the transition runs from the off-screen start position.
  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(() => cartToast.classList.add("is-visible"));
  });
  scheduleCartToastHide();
}

if (cartToast) {
  cartToast.addEventListener("click", (event) => {
    if (event.target.closest("[data-cart-toast-view]")) {
      hideCartToast();
      toggleCart(true);
      refreshMiniCart();
      return;
    }
    if (event.target.closest("[data-cart-toast-close]")) {
      hideCartToast();
    }
  });
  // Hold the toast while the shopper is reading or reaching for it.
  ["mouseenter", "focusin"].forEach((type) =>
    cartToast.addEventListener(type, () => window.clearTimeout(cartToastTimer)),
  );
  ["mouseleave", "focusout"].forEach((type) =>
    cartToast.addEventListener(type, (event) => {
      if (!cartToast.contains(event.relatedTarget)) {
        scheduleCartToastHide();
      }
    }),
  );
}

/**
 * Best-effort product name for the toast. The product and bundle modals pass
 * it as `details.name`; a loop button carries its card's title.
 */
function addedItemName($button, details) {
  if (details && details.name) {
    return String(details.name);
  }
  if ($button && $button.length) {
    const card = $button.closest("li.product, .product");
    const title = card.find(".woocommerce-loop-product__title").first();
    if (title.length) {
      return title.text().trim();
    }
  }
  return "";
}

// Adds made inside the drawer (its upsell cards, or the product modal opened
// over it) keep the drawer as their confirmation. Adds from the page show a
// toast instead, so shoppers can keep browsing. Every path triggers
// `added_to_cart`; the modals pass `details` as a fourth argument.
if (typeof jQuery !== "undefined") {
  jQuery(document.body).on(
    "added_to_cart",
    function (_event, _fragments, _cartHash, $button, details) {
      // Drop WooCommerce's "View cart" link (appended by its own handler on
      // this event — hence the trailing tick); the toast carries that action.
      if ($button && $button.length) {
        window.setTimeout(() => {
          $button.parent().find(".added_to_cart").remove();
        }, 0);
      }
      const fromDrawer =
        (cartDrawer && cartDrawer.classList.contains("is-open")) ||
        Boolean(details && details.fromDrawer);
      if (fromDrawer || !cartToast) {
        toggleCart(true);
        refreshMiniCart({ announce: true });
        return;
      }
      const name = addedItemName($button, details);
      showCartToast(name);
      announceCart(name ? `${name} added to your cart.` : "Item added to your cart.");
      // No mini-cart refresh here: "View cart" refreshes on open, and diffing
      // against the older snapshot is what highlights the new line.
    },
  );

  // Removing a line replaces the drawer through cart fragments, not through
  // refreshMiniCart(), so re-read the snapshot or the next add misreads it.
  jQuery(document.body).on(
    "removed_from_cart wc_fragments_refreshed",
    function () {
      if (cartTarget && cartSnapshot !== null) {
        cartSnapshot = snapshotMiniCart(cartTarget);
      }
    },
  );
}

// Close triggers
const closeCartBtn = document.getElementById("close-cart");
if (closeCartBtn) {
  closeCartBtn.addEventListener("click", () => toggleCart(false));
}
if (cartMask) {
  cartMask.addEventListener("click", () => toggleCart(false));
}

// ---------------------------------------------------------------------------
// Pre-checkout add-on step
// ---------------------------------------------------------------------------

/*
 * PHP renders the step inside the mini-cart fragment only when the school has
 * flagged something the bag does not already hold, so the presence of that node
 * is the whole eligibility test here — no offer, no interception, and the
 * checkout button behaves exactly as it always has.
 *
 * The step is lifted out of the fragment into a host of its own before it
 * opens: adding from inside the step refreshes the mini-cart, and a card that
 * re-rendered mid-interaction would take its own confirmation with it.
 */

const UPSELL_SEEN_KEY = "commencement_cart_upsell_seen";

upsellHost = cartDrawer ? document.createElement("div") : null;
if (upsellHost) {
  upsellHost.className = "cart-upsell-host";
  upsellHost.hidden = true;
  cartDrawer.querySelector(".drawer-inner")?.appendChild(upsellHost);
}

let upsellCheckoutUrl = "";

function upsellStepSeen() {
  try {
    return window.sessionStorage.getItem(UPSELL_SEEN_KEY) === "1";
  } catch (e) {
    // Private-mode storage failures must not block checkout.
    return true;
  }
}

function markUpsellStepSeen() {
  try {
    window.sessionStorage.setItem(UPSELL_SEEN_KEY, "1");
  } catch (e) {
    /* Nothing to do: the step simply offers itself again next click. */
  }
}

function upsellStepIsOpen() {
  return !!upsellHost && !upsellHost.hidden;
}

function openUpsellStep(source) {
  if (!upsellHost || !cartTarget) {
    return false;
  }
  const clone = source.cloneNode(true);
  clone.hidden = false;
  upsellHost.innerHTML = "";
  upsellHost.appendChild(clone);
  upsellHost.hidden = false;
  cartTarget.hidden = true;
  markUpsellStepSeen();
  // Two frames: the first mounts the node at its off-screen start, the second
  // lets the transition run from it rather than skipping to the end state.
  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(() => upsellHost.classList.add("is-open"));
  });
  clone.querySelector("[data-cart-upsell-back]")?.focus();
  announceCart("Add-ons before checkout. Continue to checkout when you are ready.");
  return true;
}

function closeUpsellStep() {
  if (!upsellHost || upsellHost.hidden) {
    return;
  }
  upsellHost.classList.remove("is-open");
  upsellHost.hidden = true;
  upsellHost.innerHTML = "";
  if (cartTarget) {
    cartTarget.hidden = false;
  }
}

/**
 * Reconcile the open step against a freshly rendered mini-cart.
 *
 * The server drops an add-on from the step the moment it enters the cart, so a
 * card missing from the new render is one the customer just added — whether
 * they added it in one tap or through the product modal. Marking it beats
 * removing it: the card is the only confirmation they get.
 */
function syncUpsellStepAfterRefresh() {
  if (!upsellStepIsOpen() || !cartTarget) {
    return;
  }
  const fresh = cartTarget.querySelector("[data-cart-upsell-step]");
  upsellHost.querySelectorAll(".cart-upsell-card").forEach((card) => {
    const id = card.getAttribute("data-api-product-id");
    const stillOffered =
      !!fresh && !!fresh.querySelector(`.cart-upsell-card[data-api-product-id="${id}"]`);
    if (!stillOffered) {
      card.classList.add("is-added");
      const action = card.querySelector(".cart-upsell-card__action");
      if (action) {
        action.setAttribute("aria-disabled", "true");
        action.textContent = "Added";
      }
    }
  });
}

if (cartTarget) {
  cartTarget.addEventListener("click", (event) => {
    const checkout = event.target.closest(".woocommerce-mini-cart__buttons a");
    if (!checkout || upsellStepSeen()) {
      return;
    }
    const step = cartTarget.querySelector("[data-cart-upsell-step]");
    if (!step) {
      return;
    }
    event.preventDefault();
    upsellCheckoutUrl = checkout.getAttribute("href") || "";
    openUpsellStep(step);
  });
}

if (upsellHost) {
  upsellHost.addEventListener("click", (event) => {
    if (event.target.closest("[data-cart-upsell-back]")) {
      closeUpsellStep();
      return;
    }
    if (event.target.closest("[data-cart-upsell-continue]") && upsellCheckoutUrl) {
      window.location.href = upsellCheckoutUrl;
      return;
    }
    // An add-on already in the bag keeps its card as a receipt, not a button.
    const spent = event.target.closest('.cart-upsell-card.is-added .cart-upsell-card__action');
    if (spent) {
      event.preventDefault();
      event.stopPropagation();
    }
  });
}

// The bundle upsell lives inside the mini-cart and opens a modal over it, so it
// needs the same close path the drawer's own controls use.
window.ThemeJS = window.ThemeJS || {};
window.ThemeJS.Cart = {
  open: () => toggleCart(true),
  close: () => toggleCart(false),
};
